"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReaderPlacement = void 0;
var ReaderPlacement;
(function (ReaderPlacement) {
    ReaderPlacement["ReaderBottom"] = "in_reader_bottom";
    ReaderPlacement["ReaderMid"] = "in_reader_mid";
    ReaderPlacement["ReaderPopUp"] = "in_reader_pop_up";
    ReaderPlacement["ReaderSticky"] = "in_reader_sticky";
    ReaderPlacement["ReaderTop"] = "in_reader_top";
    ReaderPlacement["ReaderVideo"] = "in_reader_video";
})(ReaderPlacement = exports.ReaderPlacement || (exports.ReaderPlacement = {}));
